import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faRefresh } from '@fortawesome/free-solid-svg-icons';
import GenericSidebar from './GenericSidebar';

interface SessionTimeoutSidebarProps {
  isOpen: boolean;
  onRefresh: () => void;
}

const SessionTimeoutSidebar: React.FC<SessionTimeoutSidebarProps> = ({
  isOpen,
  onRefresh,
}) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <GenericSidebar
      title="Session Timeout"
      icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
      isOpen={isOpen}
      onClose={() => {}} // Disable close button as requested
      footer={
        <div tw="text-center">
          <button
            className="contact-btn bg-brand"
            onClick={handleRefresh}
            style={{
              padding: '12px 24px',
              borderRadius: '6px',
              fontWeight: '600',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              width: '100%',
              transition: 'background-color 0.2s ease'
            }}
          >
            <FontAwesomeIcon icon={faRefresh} />
            Refresh Page
          </button>
        </div>
      }
    >
      <div tw="text-center pt-2">
        <div tw="mb-4">
          <FontAwesomeIcon 
            icon={faExclamationTriangle} 
            tw="text-yellow-500 text-6xl"
            style={{ fontSize: '64px', color: '#f59e0b' }}
          />
        </div>
        
        <h2 className="session-timeout-title" tw="mb-4">
          Session Timeout
        </h2>
        
        <div tw="">
           <p tw="mb-4" className="session-timeout-text">
             Your session has been inactive for 5 minutes. To ensure you have the most up-to-date information and prevent any issues with outdated data, please refresh the page.
           </p>
          
          <div tw="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="session-timeout-alert-text">
              Click the &quot;Refresh Page&quot; button below to continue.
            </p>
          </div>
        </div>
      </div>
    </GenericSidebar>
  );
};

export default SessionTimeoutSidebar;

